<template>
  <div class="foodtable">
    <v-simple-table dark>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Food</th>
            <th class="text-left">Temp</th>
            <th class="text-left">Duration</th>
            <th class="text-left">Notes</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in foods" :key="item.id">
            <td>{{ item.name }} <span v-if="item.frozen">(Frozen)</span></td>
            <td>{{ item.temperature }}</td>
            <td>{{ item.duration }}</td>
            <td>
              <v-dialog
                v-model="dialogs[item.name]"
                width="500"
                v-if="item.notes"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    color="red lighten-2"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    Notes
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="headline grey lighten-2">
                    {{ item.name }} Notes
                  </v-card-title>
                  <v-card-text>
                    {{ item.notes }}
                  </v-card-text>
                  <v-divider></v-divider>
                </v-card>
              </v-dialog>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'FoodTable',
  computed: mapState(['foods']),
  data() {
    return {
      dialogs: {},
    };
  },
};
</script>

<style lang="css">
.foodtable {
  margin: 1em;
}
</style>
